import { FlameIcon, Coins } from 'lucide-react';

type ActivityFilter = 'all' | 'hot' | 'trending' | 'new' | 'system' | 'cash';

interface ActivityFilterProps {
  selected: ActivityFilter;
  onChange: (filter: ActivityFilter) => void;
}

export default function ActivityFilter({ selected, onChange }: ActivityFilterProps) {
  return (
    <div>
      <div className="flex items-center space-x-2 mb-4">
        <FlameIcon className="h-5 w-5 text-red-500" />
        <span className="font-medium text-gray-700">Activity:</span>
      </div>
      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => onChange('all')}
          className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
            selected === 'all'
              ? 'bg-gray-900 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          All
        </button>
        <button
          onClick={() => onChange('hot')}
          className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-colors ${
            selected === 'hot'
              ? 'bg-red-600 text-white'
              : 'bg-red-100 text-red-800 hover:bg-red-200'
          }`}
        >
          <div className="flex -space-x-1 mr-2">
            <FlameIcon className="h-4 w-4" />
            <FlameIcon className="h-4 w-4" />
            <FlameIcon className="h-4 w-4" />
          </div>
          Hot
        </button>
        <button
          onClick={() => onChange('trending')}
          className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-colors ${
            selected === 'trending'
              ? 'bg-orange-600 text-white'
              : 'bg-orange-100 text-orange-800 hover:bg-orange-200'
          }`}
        >
          <FlameIcon className="h-4 w-4 mr-2" />
          Trending
        </button>
        <button
          onClick={() => onChange('new')}
          className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-colors ${
            selected === 'new'
              ? 'bg-green-600 text-white'
              : 'bg-green-100 text-green-800 hover:bg-green-200'
          }`}
        >
          <span className="mr-2">✨</span>
          New
        </button>
        <button
          onClick={() => onChange('system')}
          className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-colors ${
            selected === 'system'
              ? 'bg-orange-600 text-white'
              : 'bg-orange-100 text-orange-800 hover:bg-orange-200'
          }`}
        >
          <FlameIcon className="h-4 w-4 mr-2" />
          FIRESNAP
        </button>
        <button
          onClick={() => onChange('cash')}
          className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-colors ${
            selected === 'cash'
              ? 'bg-yellow-600 text-white'
              : 'bg-yellow-100 text-yellow-800 hover:bg-yellow-200'
          }`}
        >
          <Coins className="h-4 w-4 mr-2" />
          CASHSNAP
        </button>
      </div>
    </div>
  );
}